<mat-tab-group class="user-search-container">
    <mat-tab class="tabs" label="User Search">
        <mat-dialog-content fxLayout="column" style="overflow: hidden">
            <mat-form-field fxFlex>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="text" placeholder="Search" [formControl]="search"
                    (keyup)="debounceSearchUsers()" />
            </mat-form-field>

            <div fxLayoutAlign="center center" class="marine-list" *ngIf="loading">
                <mat-spinner></mat-spinner>
            </div>
            <div *ngIf="!loading" class="marine-list">
                <mat-selection-list #invitedMarines>
                    <mat-list-option *ngFor="let user of allUsers | sort: ['lastName', 'firstName']"
                        (click)="addRemoveUser(user)" [selected]="userSelected(user)" [disabled]="isUserDisabled(user)">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <img src="assets/images/no-image.png" alt="avatar" matListAvatar
                                style="margin-right: 15px;" />
                            <span>{{ user.lastName }}{{ user.lastName ? ',' : '' }} {{ user.firstName }}
                                [{{ user.email }}]</span>
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            </div>
            <mat-paginator [length]="totalUsers" [pageSize]="limitPerPage" (page)="onPageEvent($event)" [hidePageSize]="true" >
            </mat-paginator>
            <div style="overflow-y: auto; overflow-x: hidden">
                <mat-chip-list style="flex-wrap: wrap; margin-bottom: 16px;">
                    <mat-chip *ngFor="let user of selectedUsersExceptDisabled()" [removable]="true">
                        {{ user.lastName }}{{ user.lastName ? ',' : '' }} {{ user.firstName }}
                        <mat-icon matChipRemove color="warn" (click)="addRemoveUser(user)">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>
        </mat-dialog-content>
    </mat-tab>
    <ng-container *ngIf="data.searchByEmail">
        <mat-tab label="Invite by Email">
            <mat-dialog-content fxLayout="column" style="height: 350px;">
                <mat-form-field fxFlex>
                    <input matInput type="text" placeholder="Enter email address" [formControl]="email"
                        (keyup.enter)="addEmail()" />
                    <mat-icon matSuffix (click)="addEmail()">add</mat-icon>
                </mat-form-field>
                <mat-chip-list style="flex-wrap: wrap; margin-bottom: 16px; ">
                    <mat-chip *ngFor="let email of selectedEmails" [removable]="true">
                        {{ email }}
                        <mat-icon matChipRemove color="warn" (click)="removeEmail(email)">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </mat-dialog-content>
        </mat-tab>
    </ng-container>
</mat-tab-group>
<mat-dialog-actions fxLayoutAlign="end center">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button [mat-dialog-close]="{ users: selectedUsers, emails: selectedEmails }" color="primary">
        {{ data.submitButtonText }}
    </button>
</mat-dialog-actions>
